import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DocumentsListController } from './documents-list.controller';
import { DocumentsList } from './documents-list.entity';
import { DocumentsListService } from './documents-list.service';
import { DocumentsListAdapter } from './dto/documents-list.adapters';

@Module({
  imports: [
    TypeOrmModule.forFeature([DocumentsList]),
  ],
  controllers: [DocumentsListController],
  providers: [DocumentsListService,DocumentsListAdapter,ApplicationExceptionHandler]
})
export class DocumentsListModule {}
